// console.log('this is a text')

document.addEventListener('click', function(event) {
    let freeProductId = 44628455719161; // Free product ID
    let validProducts = ["metro-jetlamp-with-safety-cage", "metro", "metro-jetlamp-with-bistro"];
  
    function updateFreeProduct() {
      fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
             // console.log(cart, 'cart')
              let freeProductInCart = cart.items.some(item => item.id == freeProductId);
              // console.log(freeProductInCart, 'freeProductInCart')
              let cartTotal = cart.total_price / 100;
              let cartSubtotal = cart.items.reduce((total, item) => {
                  return item.id == freeProductId ? total : total + item.final_line_price;
              }, 0) / 100;
            let validCollectionTotal = cart.items.reduce((total, item) => {
              // console.log(item, 'item')
                if (
                    item.id !== freeProductId  &&
                    validProducts.includes(item.handle)
                ) {
                    return total + item.final_line_price;
                }
                return total;
            }, 0) / 100;
            
           let validCollectionFound = validCollectionTotal > 0;
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                cartTotal = cart.total_price / 100;
                // console.log(cart, 'cart');
                cartSubtotal = cart.items.reduce((total, item) => {
                    return item.id == freeProductId ? total : total + item.final_line_price;
                }, 0) / 100;
               freeProductInCart = cart.items.some(item => item.id == freeProductId);
               validCollectionTotal = cart.items.reduce((total, item) => {
                if (
                    item.id !== freeProductId &&
                    validProducts.includes(item.handle)
                ) {
                  // console.log('newtotal1', total + item.final_line_price)
                    return total + item.final_line_price;
                }
                 // console.log('newtotal', total)
                return total;
            }, 0) / 100;
                validCollectionFound = validCollectionTotal > 0;

              if ( validCollectionFound) {
                  if (!freeProductInCart) {
                    setTimeout(function(){
                      // $('.free_product_wrapper').trigger('click');
                    var shop_url = window.origin;

                  Data = {
                    quantity: 1,
                    id: 44628455719161,
                  };    
                      
                $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: Data,
                  success: function () {
                      $.ajax({
                        type: "GET",
                        url: "/cart?view=cart-drawer",
                        success: function (data) {
                          var cartitem = $(data).find(".drawer__cart-items-wrapper").html();
                          // console.log(cartitem, 'cartitem')
                          
                          $(".drawer__cart-items-wrapper").html(cartitem);
                          // console.log($(".drawer__cart-items-wrapper").html(cartitem), '75478684')
                           
                          setTimeout(function () {
                            // console.log('it is working')
                             $('.header__icon--cart').trigger('click');
                            $(".cart-count-number").text(cart.item_count + 1);
                          console.log(cart, 'cart', cart.item_count + 1, typeof cart.item_count + 1)
                          }, 500);
                        },
                        error: function (data) {
                          console.log(data);
                        },
                      });
                    },
                    error: function (err) {
                      console.log(err);
                    },
                   });
                      
                      // console.log('it worked')
                    },100)
                  } else {
                    console.log('Free product already in cart, skipping addition');
                  }
              } 
              else if (validCollectionTotal   < 0 && freeProductInCart) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: { id: freeProductId, quantity: 0 },
                    success: function() {
                      // setTimeout(()=>{
                      //   location.reload();
                      // },500)
                    }
                  });
              }
           })
        })
        .catch(error => console.error('Error fetching cart:', error));
      }
     setTimeout(function(){
        updateFreeProduct();
     },1000)
       updateFreeProduct();
  });

